import { PERMISSIONS } from '@core/constants/permissions.constants';
import { ReportConfig } from './sparepart-report.config';

export const JOB_CARD_SUMMARY_REPORT_CONFIG: ReportConfig = {
  id: 'job-card-summary',
  title: 'Job Card Summary Report',
  permissions: {
    view: PERMISSIONS.GSE.REPORTS.JOB_CARD_SUMMARY.VIEW,
    export: PERMISSIONS.GSE.REPORTS.JOB_CARD_SUMMARY.EXPORT,
  },
  filters: [
    {
      type: 'text',
      field: 'search',
      label: 'Search',
      placeholder: 'Search',
    },
    {
      type: 'date-range',
      field: 'dateRange',
      label: 'Date Range',
      placeholder: 'Date range',
    },
    {
      type: 'dropdown',
      field: 'jobCardStatus',
      label: 'Status',
      placeholder: 'Status',
      multiselect: false,
    },
    {
      type: 'dropdown',
      field: 'equipment',
      label: 'Equipment',
      placeholder: 'Equipment',
    },
    {
      type: 'dropdown',
      field: 'priority',
      label: 'Priority',
      placeholder: 'Priority',
      multiselect: false,
    },
  ],

  columns: [
    {
      field: 'jobCardId',
      header: 'Job Card ID',
      type: 'text',
      width: '10%',
    },
    {
      field: 'equipmentName',
      header: 'Equipment Name',
      type: 'text',
      width: '18%',
    },
    {
      field: 'startDate',
      header: 'Start Date',
      type: 'text',
      pipes: ['date'],
      width: '12%',
    },
    {
      field: 'endDate',
      header: 'End Date',
      type: 'text',
      pipes: ['date'],
      width: '12%',
    },
    {
      field: 'priority',
      header: 'Priority',
      type: 'text',
      pipes: ['replaceUnderscore', 'titlecase'],
      width: '12%',
    },
    {
      field: 'tat',
      header: 'TAT',
      type: 'number',
      width: '10%',
    },
    {
      field: 'status',
      header: 'Status',
      type: 'text',
      pipes: ['replaceUnderscore', 'titlecase'],
      width: '26%',
    },
  ],
};
